import { render, staticRenderFns } from "./FinanceSalesChannelsPage.vue?vue&type=template&id=01bf66d0&scoped=true&"
import script from "./FinanceSalesChannelsPage.vue?vue&type=script&lang=js&"
export * from "./FinanceSalesChannelsPage.vue?vue&type=script&lang=js&"
import style0 from "./FinanceSalesChannelsPage.vue?vue&type=style&index=0&id=01bf66d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf66d0",
  null
  
)

export default component.exports